'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = extractSupportQuery;

function extractSupportQuery(ruleSet) {
  return ruleSet.split('{')[0].slice(9).trim();
}